/* eslint-disable jira/filename-case */
export const SIDEBAR = 'sidebar';
export const TOP = 'top';
export const TAB = 'tab';
export const PROJECT_TITLE = 'projectTitle';

export type NavigationContainer = 'sidebar' | 'top' | 'tab' | 'projectTitle';
